<template>
    <div class="parking-plan-filter">
        <div v-if="filters" class="parking-filter__filter">
            <CheckBoxList :filter="filters"/>
        </div>
    </div>
</template>

<script>
import CheckBoxList from '../CheckboxList/CheckboxList.vue';

export default {
    props: ['filters'],

    components: {
        CheckBoxList
    }
};
</script>
